
  function parseIncomingMsgAndEncrypt(message) {
      var msgJson = JSON.parse(message);
      //var self = this;
      // if (msgJson.MSG_TYPE === "LOGIN_CLICKED") {
        var publicKeyHandle;
        var encryptAlgorithm = { name: "RSA-OAEP", hash: { name: "SHA-256" } };
        var randomSize = new Uint8Array(4);
        randomSize[0] = 0;
        randomSize[1] = 0;
        randomSize[2] = 0;
        randomSize[3] = 32;
        var publicKey = {
                          kty: "RSA",
                          ext: true,
                          n: msgJson.modulus,
                          e: msgJson.exponent
                        };

          // Import the public key using jwk format
          

          let encryptedDataPromise;
    return encryptedDataPromise = window.crypto.subtle.importKey("jwk", publicKey, encryptAlgorithm, true, ["encrypt"])
            .then(
              function (publicKey) {
                publicKeyHandle = publicKey;
                console.log(" After importing public key " +  publicKey);
                let encryptPromise = encrypt(msgJson.password, msgJson.token, publicKeyHandle, encryptAlgorithm);

                  console.log("Encrypt promise inside importKey is " +  encryptPromise);
                  return Promise.resolve(encryptPromise);
              },
              function (error) {
                return Promise.reject("Public Key import error " + error);
              }
            );
}
  function encrypt(password, randomToken, publicKeyHandle, encryptAlgorithm) {
      var randomSize = new Uint8Array(4);
      randomSize[0] = 0;
      randomSize[1] = 0;
      randomSize[2] = 0;
      randomSize[3] = 32;

      var tokenArray = base64ToArrayBuffer(randomToken);
      var pwLen = new Uint8Array(4);
      pwLen[0] = 0;
      pwLen[1] = 0;
      pwLen[2] = 0;
      pwLen[3] = password.length;
      var pw = strToUint8arr(password);
      var finalBuffer = new Uint8Array(randomSize.length + tokenArray.length + pwLen.length + pw.length);
      finalBuffer.set(randomSize);
      finalBuffer.set(tokenArray, randomSize.length);
      finalBuffer.set(pwLen, randomSize.length + tokenArray.length);
      var totalSize = randomSize.length + tokenArray.length + pw.length;
      finalBuffer.set(pw, randomSize.length + tokenArray.length + pwLen.length);
      var encryptedBytes;
      // if (!publicKeyHandle) {
      //   window.postMessage("WEBVIEW_ENCRYPTION_ERROR", "*");
      //   console.log("Invalid Key.......");
      //   return;
      // }
      //var self = this;
      //var windowSelf = window;

      var plainTextBytes = toSupportedArray(finalBuffer);

      var rsaBlock = '';
      let encryptPromise = window.crypto.subtle.encrypt(encryptAlgorithm, publicKeyHandle, plainTextBytes)
                    .then(
                      function (encrypted) {
                          encryptedBytes = toSupportedArray(encrypted);
                          var len = encryptedBytes.length;
                          var holder;
                          var bytes = new Uint8Array(len);
                          var bytesCopy = new Uint8Array(len);
                          for(var i = 0; i<len; i+=1){
                            bytesCopy[i] = encryptedBytes[i];
                            bytes[i] = encryptedBytes[i];
                          }

                          rsaBlock = btoa(String.fromCharCode.apply(null, bytesCopy));
                          
                          console.log("Encryption completed in webview, password is " +  rsaBlock);
                          //windowSelf.postMessage({'encryptedPass':rsaBlock, 'action':originType}, "*");
                          return Promise.resolve(rsaBlock);
                          // return rsaBlock;

                    },
                    function (error) {
                          rsaBlock = "ERROR";
                          //windowSelf.postMessage("WEBVIEW_ENCRYPTION_ERROR", "*");
                          return Promise.reject("Encrypt error........ " + error);
                      }
                  );
        return encryptPromise;

  }

  function toSupportedArray(data) {
        var typedArraySupport = (typeof Uint8Array !== "undefined");
        var dataType = Object.prototype.toString.call(data);
        dataType = dataType.substring(8, dataType.length - 1);
        switch (dataType) {
            case "Array":
                return typedArraySupport ? new Uint8Array(data) : data;
            case "ArrayBuffer":
                return new Uint8Array(data);
            case "Uint8Array":
                return data;
            case "Uint16Array":
            case "Uint32Array":
                return new Uint8Array(data);
            case "String":
                var newArray = typedArraySupport ? new Uint8Array(data.length) : new Array(data.length);
                for (var i = 0; i < data.length; i += 1) {
                    newArray[i] = data.charCodeAt(i);
                }
                return newArray;
            default:
                throw new Error("toSupportedArray : unsupported data type " + dataType);
        }
  }

      function getArray(myString) {
          var len = myString.length;
          var arr =[];
          for (var i = 0; i < len; i++) {
            arr[i] = myString.charCodeAt(i);
          }
          return arr;
      }

      function base64ToArrayBuffer(base64Data) {
        var binary_string =  window.atob(base64Data);
        var len = binary_string.length;
        var bytes = new Uint8Array( len );
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
      }

      function strToUint8arr(string) {
          let charList = string.split(''),
          uintArray = [];
          for (var i = 0; i < charList.length; i++) {
              uintArray.push(charList[i].charCodeAt(0));
          }
          return new Uint8Array(uintArray);
      }
export default parseIncomingMsgAndEncrypt;
